import { Box, useTheme } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

export default function DefaultLayout({ children }: Props) {
  const theme = useTheme();
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Box
        bgcolor={theme.palette.background.neutral}
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 12, md: 12 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
